'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdStyle = function MdStyle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.8 32.9v-10.6l5.7 14h-2.4c-1.8 0-3.3-1.6-3.3-3.4z m3.3-18.3c1 0 1.7-0.8 1.7-1.7s-0.7-1.6-1.7-1.6-1.6 0.7-1.6 1.6 0.7 1.7 1.6 1.7z m23.6 12c0.7 1.7-0.1 3.6-1.8 4.3l-12.2 5.1c-0.4 0.2-0.9 0.3-1.4 0.3-1.3 0-2.5-0.8-3-2.1l-8.3-20c-0.2-0.4-0.2-0.8-0.2-1.3 0-1.3 0.7-2.4 2-3l12.3-5.1c0.5-0.1 0.9-0.2 1.4-0.2 1.2 0 2.4 0.8 2.9 2z m-32.5 6.1c-1.7-0.7-2.5-2.5-1.8-4.3l4.1-9.7v15z' })
        )
    );
};

exports.default = MdStyle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/style.js
// module id = 1960
// module chunks = 168707334958949